import { useCallback, useEffect, useState } from "react";
import { t } from "app/utils";

const useConfirmClose = (confirmMessage: string, onClose: () => void, showByDefault = false) => {
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    setChanged(false);
  }, []);

  const onChange = useCallback(() => {
    setChanged(true);
  }, [setChanged]);

  const onSubmitClose = useCallback(() => {
    setChanged(false);
    onClose();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onConfirmClose = useCallback(
    () => {
      const message = t(confirmMessage);

      // eslint-disable-next-line no-alert
      if ((!changed && !showByDefault) || window.confirm(message)) {
        setChanged(false);
        onClose();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [changed, onClose]
  );

  return { onChange, onConfirmClose, onSubmitClose };
};

export default useConfirmClose;
